import { FC, useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Modal, Row } from "antd";
import Text from "antd/es/typography/Text";
import styles from "./Once.module.css";
import { addPlusToNumber, emailValid, phoneValid } from "../../../utils";
import { onceFunc } from "../../../store/actions/userAction";
import Icon from "@ant-design/icons";
import { Auth_Confirm, SetUserBlock } from "../../../store/slices/userSlice";
import { useAppDispatch, useAppSelector } from "../../../store";
import { InvisibleSmartCaptcha } from "@yandex/smart-captcha";
import { UserBlock } from "../../UserBlock/UserBlock";
import { CloseIconSmall } from "../../../assets/icons/CloseIconSmall";
import cn from "classnames";

const Once: FC = () => {
  const dispatch = useAppDispatch();
  const { _load_button, _errors, _auth, block } = useAppSelector(
    ({ userSlice }) => userSlice
  );

  const [form] = Form.useForm();

  const [showCookie, setShowCookie] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [token, setToken] = useState("");
  const [, forceUpdate] = useState({});

  const cookiesAccept = localStorage.getItem("cookiesAccept");

  const hideBlockModal = () => {
    dispatch(SetUserBlock(false));
  };

  const handleChallengeHidden = useCallback(() => setVisible(false), []);

  const onFinishHandler = () => {
    setVisible(true);
    onSubmitHandler();
  };

  const onSubmitHandler = () => {
    if (token?.length) {
      const value = form.getFieldValue("phone");
      const phone = phoneValid.test(value) && value;
      const email = emailValid.test(value) && value;

      dispatch(
        onceFunc({
          phone,
          email,
          verify_token: token,
          setVisible,
        })
      );
    }
  };

  const onClickHandler = () => {
    localStorage.setItem("cookiesAccept", "true");
    setShowCookie(false);
  };

  const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const phone = addPlusToNumber(e.target.value);

    form.setFieldsValue({ phone });
  };

  useEffect(() => {
    onSubmitHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (cookiesAccept !== "true") {
      setShowCookie(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (_auth) {
      dispatch(Auth_Confirm(false));
    }
    forceUpdate({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row justify={"center"} align={"middle"}>
      <Col span={24}>
        <Form form={form} layout="vertical" onFinish={onFinishHandler}>
          <Form.Item
            className={styles.formBlock}
            rules={[
              {
                required: true,
                message: "Введите номер телефона или email",
                min: 4,
              },
              {
                validator: (_: any, value: any) => {
                  return (value && emailValid.test(value)) ||
                    phoneValid.test(value)
                    ? Promise.resolve("okay")
                    : Promise.reject("");
                },
              },
            ]}
            name="phone"
            hasFeedback
          >
            <Input
              className={styles.inpGroup}
              onChange={onPhoneChange}
              placeholder="Телефон или email"
            />
          </Form.Item>

          <Form.Item shouldUpdate>
            {() => {
              const phone = form.getFieldValue("phone");
              const isValid =
                (!!phone && phoneValid.test(phone)) || emailValid.test(phone);

              return (
                <Button
                  type="primary"
                  htmlType="submit"
                  className={styles.buttonSubmit}
                  loading={_load_button}
                  disabled={!isValid}
                  block
                >
                  Получить код
                </Button>
              );
            }}
          </Form.Item>

          <InvisibleSmartCaptcha
            key={"captchaVisible"}
            sitekey={`${process.env.REACT_APP_CLIENT_KEY}`}
            onChallengeHidden={handleChallengeHidden}
            onSuccess={setToken}
            visible={visible}
          />

          <div className={styles.errors}>
            {_errors[0] && <Text type="danger">{_errors}</Text>}
          </div>
        </Form>
        <Modal open={block} footer={null} onCancel={hideBlockModal}>
          <UserBlock />
        </Modal>
      </Col>

      <div
        className={cn(styles.cookiesBlock, {
          [styles.visible]: showCookie,
        })}
      >
        <div className={styles.block}>
          <p className={styles.text}>
            Мы используем cookies для обеспечения лучшего опыта на нашем сайте.
            Продолжая использовать сайт, вы соглашаетесь на использование
            cookies, как описано в нашей
            <a
              href={process.env.REACT_APP_PRIVACY_POLICY}
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Политике конфиденциальности
            </a>
            .
          </p>
          <Icon
            component={CloseIconSmall}
            onClick={() => setShowCookie(false)}
          />
        </div>
        <Button
          className={styles.btnOk}
          type="primary"
          key="submit"
          onClick={onClickHandler}
        >
          Принять
        </Button>
      </div>
    </Row>
  );
};

export default Once;
